import React, { useState, useEffect, useRef } from "react";
import BharatLogo from "../../assets/images/golden-bharat.png";
import Avatar from "@mui/material/Avatar";
import picLogo from "../../assets/images/circular_logo.svg";
import notificationLogo from "../../assets/images/notifications.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import axios from "axios";
import { AUTH_URL } from "../../utils/constants";
import { toSentenceCase } from "../../utils/utils";


const OfficerHeader = () => {
  const navigate = useNavigate();
  // const name = sessionStorage.getItem("name");
  // const email = sessionStorage.getItem("email");
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const { user, logout } = useAuth();
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const getNotifiaction = async () => {
      try {
        // const res = await axios.get(`${AUTH_URL}api/notification_status?user_id=${user.userId}`, 
        const res = await axios.get(`${AUTH_URL}api/notification_status?user_id=684fbdddf3ecd75c15dd295c`,
          {
            headers: { "Content-Type": "application/json" },
          });
        setNotifications(res.data?.Final_notification_message);
      } catch (error) {
        console.log("No records")
      }
    }
    getNotifiaction();
  }, []);

  const handleSignOut = () => {
    // sessionStorage.removeItem("email");
    // sessionStorage.removeItem("name");
    // sessionStorage.removeItem("userId");
    logout();
    navigate("/");
  };

  return (
    <>
      <div className="flex justify-between px-4 py-2 items-center rounded-t-[20px] bg-white border border-[#E7F3FF] ">
        <div className="flex items-center ml-1.5 cursor-pointer" onClick={() => { navigate("/") }}>
          <img
            alt="bihar_logo"
            src={BharatLogo}
            className=" h-[50px] w-auto "
          />
          {/* <div className="text-[#414141] text-[20px] font-[Roboto] font-medium mx-4 ">
            <h1>जनसुनवाई -समाधान</h1>
            <hr />
            <h1 className="text-[#5D5D5D] text-[16px] font-normal ">
              Government of Uttar Pradesh
            </h1>
          </div> */}
        </div>
        <div className="flex flex-col items-end gap-y-1 w-[25%] text-[#f2f2f6] font-poppins ">
          <div className="flex relative items-center gap-x-3 text-[16px] text-black ">
            <div className="w-[36px] h-[36px] mr-3 rounded-full overflow-hidden bg-[#F4F5F5] p-2 ">
              <img
                src={notificationLogo}
                alt="notification"
                className="object-cover "
              />
            </div>

            <button onClick={toggleMenu}>
              <Avatar
                src={picLogo || "/broken-image.jpg"}
                sx={{ height: "40px" }}
              />
            </button>
            <p>
              <span className="font-bold ">{toSentenceCase(user.name)}</span>
            </p>
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          ref={menuRef}
          className="absolute top-[70px] right-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-10 overflow-hidden"
        >
          <div className="p-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-center">
            <p className="font-semibold">
              Hello, {toSentenceCase(user.name)}!
            </p>
            <p className="text-sm opacity-80">{user.email}</p>
          </div>
          <ul className="divide-y divide-gray-100">
            <li>
              <button
                onClick={handleSignOut}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Sign Out
              </button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default OfficerHeader;
